import { render } from "./CaseDetailsDialog.vue?vue&type=template&id=c4aa647e&scoped=true"
import script from "./CaseDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CaseDetailsDialog.vue?vue&type=script&lang=js"

import "./CaseDetailsDialog.vue?vue&type=style&index=0&id=c4aa647e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4aa647e"]])

export default __exports__